module.exports = __webpack_public_path__ + "static/img/right-top-corner.6375afd1.png";